import {
  Banknote,
  Beer,
  Bell,
  Bike,
  BookOpen,
  Building2,
  Bus,
  Cake,
  Calendar,
  CalendarCheck,
  CalendarDays,
  Camera,
  Car,
  ChefHat,
  ClipboardList,
  Coffee,
  Coins,
  CreditCard,
  Drum,
  Dumbbell,
  FileText,
  Flag,
  Gift,
  Globe,
  Guitar,
  HandCoins,
  Heart,
  HeartHandshake,
  IdCard,
  KeyRound,
  Landmark,
  Lock,
  Mail,
  MapPin,
  Medal,
  Megaphone,
  MessageCircle,
  Mic,
  Music,
  Newspaper,
  Paintbrush,
  PartyPopper,
  Phone,
  PiggyBank,
  Pizza,
  Printer,
  Puzzle,
  QrCode,
  Receipt,
  Send,
  Shield,
  Shirt,
  ShoppingBag,
  ShoppingCart,
  Sparkles,
  Star,
  Tent,
  Ticket,
  TrendingUp,
  Trophy,
  Truck,
  Users,
  Utensils,
  Vault,
  Video,
  Wallet,
  Wine,
  Wrench,
} from 'lucide-react';

/**
 * Les icônes que le catalogue de la boutique peut poser sur un module.
 *
 * Miroir du catalogue du shop (shop/frontend/src/icones.ts) : un nom
 * enregistré au back-office se rend ici à l'identique — un nom inconnu
 * retombe sur la pièce de puzzle.
 */
export const ICONES_MODULES: Record<string, typeof Puzzle> = {
  'shopping-bag': ShoppingBag,
  'shopping-cart': ShoppingCart,
  ticket: Ticket,
  'qr-code': QrCode,
  'credit-card': CreditCard,
  wallet: Wallet,
  banknote: Banknote,
  coins: Coins,
  'piggy-bank': PiggyBank,
  'hand-coins': HandCoins,
  receipt: Receipt,
  'trending-up': TrendingUp,
  utensils: Utensils,
  'chef-hat': ChefHat,
  beer: Beer,
  coffee: Coffee,
  wine: Wine,
  pizza: Pizza,
  cake: Cake,
  'party-popper': PartyPopper,
  music: Music,
  mic: Mic,
  guitar: Guitar,
  drum: Drum,
  camera: Camera,
  video: Video,
  trophy: Trophy,
  medal: Medal,
  dumbbell: Dumbbell,
  bike: Bike,
  tent: Tent,
  flag: Flag,
  'map-pin': MapPin,
  bus: Bus,
  truck: Truck,
  car: Car,
  calendar: Calendar,
  'calendar-check': CalendarCheck,
  'calendar-days': CalendarDays,
  'file-text': FileText,
  'clipboard-list': ClipboardList,
  'book-open': BookOpen,
  newspaper: Newspaper,
  printer: Printer,
  users: Users,
  'id-card': IdCard,
  'building-2': Building2,
  landmark: Landmark,
  heart: Heart,
  'heart-handshake': HeartHandshake,
  gift: Gift,
  star: Star,
  sparkles: Sparkles,
  shirt: Shirt,
  mail: Mail,
  send: Send,
  megaphone: Megaphone,
  'message-circle': MessageCircle,
  phone: Phone,
  bell: Bell,
  globe: Globe,
  lock: Lock,
  'key-round': KeyRound,
  vault: Vault,
  shield: Shield,
  wrench: Wrench,
  paintbrush: Paintbrush,
};

export { Puzzle as IconeModuleParDefaut };
